import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-project-task-sign-info',
  templateUrl: './project-task-sign-info.component.html',
  styleUrls: ['./project-task-sign-info.component.css', '../signaling-info/signaling-info.component.css', '../info-window-dinamic.component.css']
})
export class ProjectTaskSignInfoComponent implements OnInit {

  @Input() projectTaskSign;
  url = '';
  ngOnInit(): void {
    if (this.projectTaskSign?.taskId) this.url = environment.uri() + `/#/services/task/resume/task-resume/${this.projectTaskSign?.taskId}`;
    else if (this.projectTaskSign?.projectId) this.url = environment.uri() + `/#/projects/display/${this.projectTaskSign?.projectId}`;
  }
}
